export const MyBilling = () => {
  return (
    <div>
      <h1 className="text-center">My Billing</h1>
    </div>
  )
}
